import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { Divider, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { type ConditionSpecsFragment } from '../../../../api/fragments/ConditionSpecs';
import { StyledCondition } from './Condition';
import ConditionContainer from './ConditionContainer';

export type ConditionGroupProps = {
    childrenConditions: ConditionSpecsFragment[];
    onClick: () => void;
    onGroupDelete: () => void;
};

const StyledConditionGroup = styled.div`
    flex-direction: column;
    width: 100%;

    .ant-divider {
        margin: 8px 0;
        font-size: 12px;
    }
`;

const StyledConditionGroupLabel = styled.div`
    align-self: center;
    width: 100%;
`;

const StyledActions = styled.div`
    margin-top: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const ConditionGroup = ({ childrenConditions, onClick, onGroupDelete }: ConditionGroupProps) => {
    const { t } = useTranslation('consentsAndDeclarations');

    return (
        <StyledCondition>
            <StyledConditionGroup>
                <StyledConditionGroupLabel>
                    {childrenConditions.map((child, index) => {
                        if (index > 0) {
                            return (
                                <>
                                    <Divider>{t('consentsAndDeclarations:orDivider')}</Divider>
                                    <ConditionContainer
                                        conditionSettings={child}
                                        onClick={onClick}
                                        onDelete={onGroupDelete}
                                        logicCondition
                                    />
                                </>
                            );
                        }

                        return (
                            <ConditionContainer
                                conditionSettings={child}
                                onClick={onClick}
                                onDelete={onGroupDelete}
                                logicCondition
                            />
                        );
                    })}
                </StyledConditionGroupLabel>
                <StyledActions>
                    <Button icon={<PlusOutlined />} onClick={onClick} type="link">
                        {t('consentsAndDeclarations:addConditionInGroup')}
                    </Button>
                    <Divider type="vertical" />
                    <Button icon={<DeleteOutlined />} onClick={onGroupDelete} type="link">
                        {t('consentsAndDeclarations:removeCondition')}
                    </Button>
                </StyledActions>
            </StyledConditionGroup>
        </StyledCondition>
    );
};
